<template>
  <div id="app" style="padding: 0px;margin: 0px;">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  created() {
  },
  methods: {
  }
}
</script>

<style>
@font-face {
  font-family: 'YouSheBiaoTiHei';
  src: url("./assets/ttf/YouSheBiaoTiHei.ttf");
}
@font-face {
  font-family: 'Alibaba PuHuiTi 3.0';
  src: url("./assets/ttf/AlibabaPuHuiTi-3-55-RegularL3.ttf");
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app{
  background: #F4F5FA;
}
.tox-tinymce-aux{
  z-index: 99999!important;
}
</style>
<style lang="scss">

.hollow{
  background: #FFFFFF!important;
  border: 1px solid $mainColor!important;
  border-radius: 4px!important;
  color: $mainColor;
}
</style>
